var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { stroke: "#258518", strokeWidth: "2", transform: "matrix(-1 0 0 1 58 12)" },
        React.createElement("path", { fill: "#FFF", d: "M4 5a3 3 0 0 0-3 3v21a1 1 0 0 0 1 1h52a1 1 0 0 0 1-1v-4.648a1 1 0 0 0-.005-.102L53.299 7.694A3 3 0 0 0 50.315 5H4z" }),
        React.createElement("circle", { cx: "9.5", cy: "30.5", r: "4.5", fill: "#FFF" }),
        React.createElement("path", { fill: "#FFF", d: "M45.5 35a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z" }),
        React.createElement("path", { d: "M54.687 20L53.502 9H45a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9.687z" }),
        React.createElement("rect", { width: "29", height: "7", x: "10", y: "9", rx: "2" }),
        React.createElement("path", { d: "M1 9v7h3a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H1z" }),
        React.createElement("path", { fill: "#FFF", d: "M8 5h18.131L24.06 1.89A2 2 0 0 0 22.394 1H10a2 2 0 0 0-2 2v2z" }),
        React.createElement("path", { d: "M16 10v5M24 10v5M32 10v5" }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M1 21h2" })
      ),
      React.createElement("path", { stroke: "#FFF", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2.5", d: "M9.5 53l46-46" }),
      React.createElement("path", { stroke: "#258518", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M7 53L53 7" })
    )
  );
});